export default "__VITE_ASSET__8738a6ca__"